import React from "react";

const replaceKeywordsWithComponents = (str, keywords, components) => {
  return str
    .split(new RegExp(`(${keywords.join("|")})`))
    .map((substr, index) => {
      if (substr.indexOf("#") < 0) {
        return substr;
      } else {
        const nameWithoutHash = substr.replaceAll("#", "");
        const component = components[nameWithoutHash];
        return React.createElement(component, { key: index });
      }
    });
};

export default replaceKeywordsWithComponents;
